/**
 * Mirrors WebApi Models.Common.NewViewerBackend.KollelManagementTabType (HAT-1446 phase 5) — the
 * status tabs of the admin "אישור כוללים" screen. Numeric, same shape as
 * ProjectManagementTabType.
 *
 * Unlike projects, each tab maps to exactly one status today (KollelStatusDefinitions.Tabs) - the
 * spec describes a single welfare-committee review stage, not several sub-stages.
 */
export enum KollelManagementTabType {
  /** ממתין לאישור (ועדת רווחה) */
  PendingApproval = 1,
  /** מאושר */
  Approved = 2,
  /** נדחה */
  Rejected = 3,
}
